<template>
    <div class="relative">
        <div class="absolute flex items-center justify-end gap-2 left-0 -translate-x-full text-right px-2 py-3 text-sm mobile:text-xs  text-grey-600 w-64 mobile:w-32 leading-tight" :class="{'hover:text-primary-400 hover:underline': link}">
            <template v-if="link">
                <a v-if="icon" :href="link" target="_blank" :title="label">
                    {{label?.truncate(28)}}
                </a>
            </template>
            <span :title="label" v-else>
                {{label?.truncate(28)}}
            </span>
            <i v-if="icon" class="far text-sm mobile:hidden text-grey-600" v-bind:class="'fa-' + icon"></i>
        </div>
        <div class="relative w-full flex items-center py-5 border-t border-grey-200">
            <cw-period v-for="(period, index) in periods"
                       v-bind="period"
                       :key="index"
                       :index="index"
                       :red="red"
                       :label="label"
                       :timeline-start="timelineStart"
                       :company-end-date="companyEndDate"
                       :timeline-end="timelineEnd"
                        :isMandateHolder="isMandateHolder">
            </cw-period>
            <cw-event v-for="(event, index) in events"
                      v-bind="event"
                      :key="index"
                      :index="index"
                      :timeline-start="timelineStart"
                      :timeline-end="timelineEnd">
            </cw-event>
        </div>
    </div>
</template>

<script lang="ts">
    import CwEvent from './event.vue';
    import CwPeriod from './period.vue';
    import {defineComponent} from 'vue';
    import {TimelineEvent, Period} from "./types";

    export default defineComponent({
        name: 'cw-track',
        components: {
            CwPeriod,
            CwEvent
        },
        props: {
            label: String,
            type: String,
            link: String,
            red: Boolean,
            periods: Array as () => Period[],
            events: Array as () => TimelineEvent[],
            forcedColor: String,
            timelineStart: {
                type: Number,
                required: true
            },
            timelineEnd: {
                type: Number,
                required: true
            },
            companyEndDate: {
                type: Number,
                required: true
            },
        },
        computed: {
            isMandateHolder(): boolean {
                return this.type === 'person' || this.type === 'company';  
            },
            icon(): string {
                if (this.type === 'person')
                    return 'user-tie';
                else if (this.type === 'company')
                    return 'buildings';
                else
                    return '';
            }
        }
    });
</script>